export default "__VITE_ASSET__ChZOUZWy__"